exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".customTab>.ant-tabs>.ant-tabs-left-content{border-left:0;overflow:visible}.customTab>.ant-tabs>.ant-tabs-right-content{overflow:visible}\n", ""]);
